import React, { useState } from "react";
import styled from "styled-components";

import Dropdown, { DropdownContainer } from "./Dropdown";
import Icon, { ClickableIcon } from "./Icon";
import _theme from "../styles/theme";

type ProgramDropdownProps = {
  program: { [key: string]: any };
  openEditModal: (x: any) => void;
  openEditGraduateModal: (x: any) => void;
  openEditAlternativeAwardModal: (x: any) => void;
  openEditSuspendModal: (x: any) => void;
  openGraduateModal: (x: any) => void;
  openWithdrawModal: (x: any) => void;
  openLeaveModal: (x: any) => void;
  openSuspendModal: (x: any) => void;
  openTerminateModal: (x: any) => void;
  openAlternativeAward: (x: any) => void;
  openEnrollModal: (x: any) => void;
};
const DropdownItem = styled.div`
  text-decoration: none !important;
  padding: ${({ theme }) => theme.spacing.x1}
    ${({ theme }) => `${theme.spacing.base * 1.5}px`};
  color: ${({ theme }) => theme.color.textColor};
  /* font-size : 14px; */
  text-align: left;
  &:hover {
    background-color: ${({ theme }) => theme.color.lightBackground};
  }
`;

const StudentProgramDropdown = ({
  program,
  openEditModal,
  openEditGraduateModal,
  openEditAlternativeAwardModal,
  openEditSuspendModal,
  openGraduateModal,
  openWithdrawModal,
  openSuspendModal,
  openLeaveModal,
  openTerminateModal,
  openAlternativeAward,
  openEnrollModal
}: ProgramDropdownProps) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <DropdownContainer>
      <ClickableIcon
        ml={0.5}
        size={2}
        name="more-vertical"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!isOpen);
        }}
        style={{ color: _theme.color.primary }}
      />
      <Dropdown
        open={isOpen}
        style={{ whiteSpace: "nowrap", cursor: "pointer" }}
        setOpen={setOpen}
        align="right"
      >
        {/* <DropdownItem
          style={{ minWidth: 100 }}
          // to="#"
          onClick={(e) => {
            // e.stopPropagation();
            setOpen(false);
            openEditModal(program);
          }}
        >
          <Icon mr={1} name="pencil-edit" /> Edit
        </DropdownItem> */}
        { program.status !== "SUSPENDED" &&
          <DropdownItem
            style={{ minWidth: 100 }}
            // to="#"
            onClick={(e) => {
              // e.stopPropagation();
              setOpen(false);
              program.status === "GRADUATED"
                ? openEditGraduateModal(program)
                : program.status === "ALTERNATIVE DEGREE AWARD"
                  ? openEditAlternativeAwardModal(program)
                    : program.status === "SUSPENDED"
                      ? openEditSuspendModal(program)
                      : openEditModal(program);
            }}
          >
            <Icon mr={1} name="pencil-edit" /> Edit
          </DropdownItem>
        }
        {program.status !== "GRADUATED" && program.status !== "TERMINATED" && program.status !== "WITHDRAWN" && program.status !== "ALTERNATIVE DEGREE AWARD" && program.status !== "ENROLLED" && (
          <DropdownItem
            onClick={(e) => {
              // e.stopPropagation();
              setOpen(false);
              openEnrollModal(program);
            }}
          >
            <Icon mr={1} name="check-mark" /> Enroll
          </DropdownItem>
        )}
        {program.status !== "GRADUATED" && program.status !== "ALTERNATIVE DEGREE AWARD" && (
          <>
            {/* <DropdownItem
              // to="#"
              onClick={(e) => {
                // e.stopPropagation();
                setOpen(false);
                openLeaveModal(program);
              }}
            >
              <Icon mr={1} name="pencil-edit" /> Leave of Absence
            </DropdownItem> */}



            {program?.degree_abbr?.includes("Ph.D") && program.status === "ENROLLED" &&
              <DropdownItem
                onClick={(e) => {
                  // e.stopPropagation();
                  setOpen(false);
                  openAlternativeAward(program);
                }}
              >
                <Icon mr={1} name="verified" /> ALTERNATIVE DEGREE AWARD
              </DropdownItem>}
            {program.status !== "GRADUATED" && program.status !== "ON LEAVE" && program.status !== "SUSPENDED" && <DropdownItem
              // to="#"
              onClick={(e) => {
                // e.stopPropagation();
                setOpen(false);
                openLeaveModal(program);
              }}
            >
              <Icon mr={1} name="pencil-edit" /> Leave
            </DropdownItem>}

            {program.status !== "SUSPENDED" && <DropdownItem
              onClick={(e) => {
                // e.stopPropagation();
                setOpen(false);
                openSuspendModal(program);
              }}
            >
              <Icon mr={1} name="player-pause" /> Suspend
            </DropdownItem>}

            <DropdownItem
              onClick={(e) => {
                // e.stopPropagation();
                setOpen(false);
                openTerminateModal(program);
              }}
            >
              <Icon mr={1} name="player-stop" /> Terminate
            </DropdownItem>
            <DropdownItem
              onClick={(e) => {
                // e.stopPropagation();
                setOpen(false);
                openWithdrawModal(program);
              }}
            >
              <Icon mr={1} name="circle-arrow-left" /> Withdraw
            </DropdownItem>
            {program.status !== "ON LEAVE" && program.status !== "SUSPENDED" && (
              <DropdownItem
                onClick={(e) => {
                  // e.stopPropagation();
                  setOpen(false);
                  openGraduateModal(program);
                }}
              >
                <Icon mr={1} name="google" /> Graduate
              </DropdownItem>
            )}
          </>
        )}
      </Dropdown>
    </DropdownContainer>
  );
};

export default StudentProgramDropdown;
